<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>

            <!-- filter -->
            <b-row v-if="!hasErrors" class="mb-3">
                <b-col md="3" class="my-1">
                    <dead-line-filter/>
                </b-col>
                <b-col md="3" class="my-1">
                    <situation-reporting-filter/>
                </b-col>
                <b-col md="3" offset-md="3" class="my-1">
                    <b-form-group class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                v-model="filter"
                                placeholder="Entrer la valeur recherchée"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="resetSearch"
                                >
                                    Effacer
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- /filter -->

            <!-- Table -->
            <b-table
                responsive
                small
                striped
                :items="filteredItems"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="['search']"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="client_id"
                @filtered="onFiltered"
            >
                <template #cell(client.email)="data">
                    <span v-html="handleEmail(data.item.client.email)"></span>
                </template>
                <template #cell(client.name)="data">
                    <span v-html="handleHomeRoute(data.item.client)"></span>
                </template>
                <template #cell(client.history_route)="data">
                    <comments-block
                        :key="'cb' + data.item.client.id"
                        :client="data.item.client"
                        :type="'sit'"
                    />
                </template>
                <template #cell(client.deadlines_route)="data">
                    <span
                        v-html="
                            handleDeadlinesRoute(data.item.client, 'situation')
                        "
                    ></span>
                </template>
                <template #cell(client.enable_time_sheets)="data">
                    <time-sheet-handler :client="data.item.client"/>
                </template>
                <template #cell(client.end_of_exercise)="data">
                    <end-of-exercise
                        :month="data.item.client.end_of_exercise"
                    ></end-of-exercise>
                </template>
                <template #cell(m1.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm1'"
                        :deadlines="data.item.m1.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m2.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm2'"
                        :deadlines="data.item.m2.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m3.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm3'"
                        :deadlines="data.item.m3.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m4.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm4'"
                        :deadlines="data.item.m4.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m5.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm5'"
                        :deadlines="data.item.m5.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m6.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm6'"
                        :deadlines="data.item.m6.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m7.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm7'"
                        :deadlines="data.item.m7.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m8.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm8'"
                        :deadlines="data.item.m8.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m9.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm9'"
                        :deadlines="data.item.m9.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m10.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm10'"
                        :deadlines="data.item.m10.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m11.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm11'"
                        :deadlines="data.item.m11.data"
                        @update-table="getItems"
                    />
                </template>
                <template #cell(m12.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm12'"
                        :deadlines="data.item.m12.data"
                        @update-table="getItems"
                    />
                </template>
            </b-table>
            <!-- /Table -->

            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
        <b-modal
            :id="'modal-time-sheet'"
            title="Saisie des temps"
            size="sm"
            hide-footer
            no-close-on-backdrop
        >
            <time-sheet-modal/>
        </b-modal>
    </div>
</template>

<script>
import deadlinesHandler from '../components/DeadlinesHandlerNew.vue'
import endOfExercise from '../components/EndOfExerciseNew.vue'
import loading from '../../../common/components/loading'
import TableHandler from '../../../common/mixins/TableHandler'
import DashboardHandler from '../../../dashboard/mixins/DashboardHandler'
import DeadLineFilter from '../components/DeadLineFilter'
import BeforeFilter from '../components/BeforeFilter'
import TimeSheetHandler from '../components/TimeSheetHandler'
import TimeSheetModal from '../components/TimeSheetModal'
import SearchFilter from '../components/SearchFilter'
import {mapState} from 'vuex'
import SituationReportingFilter from "../components/SituationReportingFilter.vue";

export default {
    name: 'TableSituations',

    components: {
        SituationReportingFilter,
        SearchFilter,
        TimeSheetHandler,
        TimeSheetModal,
        DeadLineFilter,
        BeforeFilter,
        deadlinesHandler,
        endOfExercise,
        loading,
    },

    mixins: [TableHandler, DashboardHandler],

    data() {
        return {
            filter: 'sit_rep',
            fields: [
                {
                    key: 'client.email',
                    label: '',
                    sortable: false,
                    class: 'td-icon',
                },

                {
                    key: 'client.deadlines_route',
                    label: '',
                    sortable: false,
                    class: 'td-icon',
                },
                {
                    key: 'client.enable_time_sheets',
                    label: '',
                    sortable: false,
                    class: 'td-icon',
                },
                {
                    key: 'client.name',
                    label: 'Raison sociale',
                    class: 'td-sm td-bold',
                    sortable: true,
                },
                {
                    key: 'client.revision_user_initials',
                    label: 'Rév.',
                    class: 'td-sm text-center',
                    sortable: true,
                },
                {
                    key: 'client.history_route',
                    label: 'Commentaire',
                    sortable: true,
                    class: 'td-sm ',
                },
                {
                    key: 'client.end_of_exercise',
                    label: 'Fin exe.',
                    sortable: true,
                    class: 'td-sm text-center',
                },
                {
                    key: 'm1.sort',
                    label: 'jan',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm2.sort',
                    label: 'fév',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm3.sort',
                    label: 'mar',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm4.sort',
                    label: 'avr',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm5.sort',
                    label: 'mai',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm6.sort',
                    label: 'jun',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm7.sort',
                    label: 'jul',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm8.sort',
                    label: 'aou',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm9.sort',
                    label: 'sep',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm10.sort',
                    label: 'oct',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm11.sort',
                    label: 'nov',
                    sortable: true,
                    class: 'text-center',
                },
                {
                    key: 'm12.sort',
                    label: 'déc',
                    sortable: true,
                    class: 'text-center',
                },
            ],
        }
    },

    computed: {
        ...mapState({
            activationFilter: (state) => state.browsing.clientsActivationFilter,
            situationReportingFilter: (state) => state.browsing.situationReportingFilter,
        }),
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'sit')
        this.$store.commit('browsing/SET_SITUATION_REPORTING_TAX_FILTER', this.filter)
        this.getItems()
        this.$store.commit(
            'timeSheetsVM/SET_CURRENT_DATE',
            this.$moment().format('Y-MM-DD')
        )
        this.$store.commit('timeSheetsVM/SET_PAGE_CODE', 'sit')
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/reporting/get-data/optimized/${this.situationReportingFilter}/${this.year}`
                )
                this.items = response.data.data
                this.filterItems()
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        async getUpdatedItem(client_id, month) {
            try {
                const response = await axios.get(
                    `/reporting/get-data/optimized/sit/${this.year}/${client_id}`
                )
                this.updatedItem = response.data.data[0]
                this.updateMonthData(client_id, month)
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        filterItems() {
            switch (this.activationFilter) {
                case 'active':
                    this.items = this.items.filter(
                        (item) => item.client.is_active
                    )
                    break
                case 'old':
                    this.items = this.items.filter(
                        (item) => !item.client.is_active
                    )
                    break
                default:
                    break
            }
            this.updateTotalRows()
        },
    },
}
</script>
